import { Outlet } from "react-router-dom";

import { AppSidebar } from "@/components/app-sidebar";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import ReloadPrompt from "@/pwa/reload-prompt";
import { PusherProvider } from "@/services/context/pusher/pusher-context";

import { BreadcrumbWithRoutingLibrary } from "../breadcrumb";
import MobileBottomNav from "../mobile-navigation";

export default function MainLayout() {
  return (
    <PusherProvider>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <header className="bg-background sticky top-0 flex shrink-0 items-center gap-2 p-2 pt-[calc(0.5rem+max(12px,env(safe-area-inset-top,0px)))]">
            <BreadcrumbWithRoutingLibrary />
          </header>
          {/*
            The page body is the scroller on every screen. overflow-y: auto
            computes the other axis to auto, so a sideways swipe is a
            horizontal scrollport and at the end it chains into browser back.
            clip on X is not a scrollport, so vertical scrolling stays and
            that chain does not. Touch and a mouse both still scroll the page.
          */}
          <div
            content="main"
            className="min-h-0 flex-1 overflow-x-clip overflow-y-auto p-2"
          >
            <Outlet />
          </div>
          <MobileBottomNav />
        </SidebarInset>
      </SidebarProvider>
      <ReloadPrompt />
    </PusherProvider>
  );
}
